// component-collection-tabs.js
if (typeof CollectionTabs !== "function") {
  class CollectionTabs extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      // Prevent duplicate listeners if Shopify theme editor reloads the section
      if (this.dataset.initialized === "true") return;
      this.dataset.initialized = "true";

      const tabs = Array.from(this.querySelectorAll(".collection-tabs_tab"));
      const panels = Array.from(this.querySelectorAll(".collection-tabs_panel"));
      const viewCollectionLink = this.querySelector(".section-heading__actions a");
      const viewCollectionLink2 = this.querySelector(".js-view-collection-link");

      if (!tabs.length || !panels.length) return;

      const setActivePanel = (panelId) => {
        panels.forEach((panel) => {
          const isActive = panel.id === panelId;
          panel.classList.toggle("active", isActive);
          panel.setAttribute("aria-hidden", isActive ? "false" : "true");

          if (isActive) {
            const slider = panel.querySelector("css-slider");
            if (slider && typeof slider.resetSlider === "function") {
              slider.resetSlider();
            }
          }
        });
      };

      const activateTab = (tabItem, { focus = true } = {}) => {
        const tabButton = tabItem?.querySelector("button");
        if (!tabButton) return;

        // Deactivate all tabs
        tabs.forEach((t) => {
          t.classList.remove("active");
          const btn = t.querySelector("button");
          if (btn) {
            btn.setAttribute("aria-selected", "false");
            btn.setAttribute("tabindex", "-1");
          }
        });

        // Activate current tab
        tabItem.classList.add("active");
        tabButton.setAttribute("aria-selected", "true");
        tabButton.removeAttribute("tabindex");

        if (focus) tabButton.focus();

        const targetPanelId = tabButton.getAttribute("aria-controls");
        const collectionUrl = tabButton.getAttribute("data-collection-url");

        if (collectionUrl) {
          if (viewCollectionLink) viewCollectionLink.setAttribute("href", collectionUrl);
          if (viewCollectionLink2) viewCollectionLink2.setAttribute("href", collectionUrl);
        }

        if (targetPanelId) setActivePanel(targetPanelId);
      };

      // Wire events
      tabs.forEach((tab, index) => {
        const button = tab.querySelector("button");
        if (!button) return;

        // Click: activate without forcing focus jump (mouse already focused)
        button.addEventListener("click", (e) => {
          e.preventDefault();
          activateTab(tab, { focus: false });
        });

        // Keyboard navigation (Arrow Keys)
        button.addEventListener("keydown", (e) => {
          let targetIndex = null;

          if (e.key === "ArrowLeft") {
            targetIndex = index - 1;
            if (targetIndex < 0) targetIndex = tabs.length - 1;
          } else if (e.key === "ArrowRight") {
            targetIndex = index + 1;
            if (targetIndex >= tabs.length) targetIndex = 0;
          } else if (e.key === "Home") {
            targetIndex = 0;
          } else if (e.key === "End") {
            targetIndex = tabs.length - 1;
          }

          if (targetIndex !== null) {
            e.preventDefault();
            activateTab(tabs[targetIndex], { focus: true });
          }
        });
      });

      // Initialize first tab + panel without focus
      activateTab(tabs[0], { focus: false });
    }
  }

  if (typeof customElements.get("collection-tabs") === "undefined") {
    customElements.define("collection-tabs", CollectionTabs);
  }

  document.addEventListener("shopify:section:load", (e) => {
    if (e.target.classList.contains("mount-collection-tabs")) {
      const el = e.target.querySelector("collection-tabs");
      if (!el) return;

      // Allow re-init on reloaded section instance
      delete el.dataset.initialized;
      el.init();
    }
  });
}
